import React,{useState} from 'react';
import axios from 'axios';
import { getApiBaseUrl } from './uploadUrl';

import './AuthModal.css';



const AuthModal=({ showModal, setshowModal, onLoginSuccess })=>{
  
    const [islogin,setislogin]=useState(false);
    const [name,setname]=useState("");
    const [email,setemail]=useState("");
    const [password,setpassword]=useState("");
    const base = getApiBaseUrl();
    
    const handlelogin= async(e)=>{
        e.preventDefault();
     try{
        const res = await axios.post(`${base}/api/authentication/authlogin`, {
            email, password
        });
      localStorage.setItem('user', JSON.stringify(res.data.user));
        localStorage.setItem('userId', res.data.user?.id ?? '');
      if(onLoginSuccess) onLoginSuccess();
      setshowModal(false);
    }catch(error){
        console.log(error);
        alert(error?.response?.data?.message || 'Login failed');
     }
    
    }

    const handleregister=async(e)=>{
        e.preventDefault();
        try{
          const res=await axios.post(`${base}/api/authentication/authregister`,{
            name,email,password,role:'user'
          })
         localStorage.setItem('user', JSON.stringify(res.data.user));
          localStorage.setItem('userId', res.data.user?.id ?? '');
          if(onLoginSuccess) onLoginSuccess();
          setshowModal(false);

        }catch(error){
          console.log(error);
          alert(error?.response?.data?.message || 'Register failed');
        }
    }

    if(!showModal){
        return null;
    }

    return(
     <div className="auth-overlay">
         <div className="auth-modal">
            <button className="close-btn" onClick={()=>setshowModal(false)}>
                 ×
            </button>
            <h2>{islogin?"Login":"Register"}</h2>
            <form onSubmit={
                islogin?handlelogin:handleregister
            }>
            {!islogin && (
               <>
               <input type="text" placeholder="Name" value={name} onChange={(e)=>setname(e.target.value)}/>
               </>
               )}

                    <input type="email" autoComplete="email" placeholder="Email" value={email} onChange={(e)=>setemail(e.target.value)}/>

                   <input type="password" autoComplete={islogin ? 'current-password' : 'new-password'} placeholder="Password" value={password} onChange={(e)=>setpassword(e.target.value)}/>
            
               <button type="submit" className="submit-btn">{islogin?"Login":"Register"}</button>

      <div className="switch-auth">

                {islogin ? "Dont have any account" : "Already have an account"}
                <span onClick={() => setislogin(!islogin)}>
                   {islogin ? "Register" : "Login"}</span>

                {islogin && (
                  <div style={{ marginTop: 10 }}>
                    <a className="authLink" href="/forgot-password" style={{ display: 'inline-block' }}>
                      Forgot password?
                    </a>
                  </div>
                )}

               </div>

            </form>
         </div>
     </div>
    )

}

export default AuthModal;



    